"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnauthorizedError = void 0;
const http_error_1 = require("./http-error");
class UnauthorizedError extends http_error_1.HttpError {
    constructor(message = "Unauthorized") {
        super(message, 401, "errors/unauthorized");
    }
}
exports.UnauthorizedError = UnauthorizedError;
